import { FormattedMessage } from 'react-intl'

import { useMediaQuery } from '@gto/ui/hooks/use-media-query'
import { Typography } from '@gto/ui/typography'

import { FolderCheckmarkIcon, ReportRegistrationIcon, ReportStepsIcon } from '@/assets/icons'
import type { Translations } from '@/localise'

const reportStepsIcons = [FolderCheckmarkIcon, ReportStepsIcon, ReportRegistrationIcon]

export const ReportFromDealSteps = () => {
  const isSmAndLower = useMediaQuery('down', 'sm')

  return (
    <div className="flex flex-col gap-5">
      {reportStepsIcons.map((Icon, index) => (
        <div
          // eslint-disable-next-line @eslint-react/no-array-index-key -- fixed 3-step icon list, never reorders
          key={index}
          className="flex items-center gap-3"
        >
          <div className="flex-[0_0_auto]">
            <Icon />
          </div>
          <Typography variant={isSmAndLower ? 'body2' : 'body1'}>
            <FormattedMessage
              id={`reportUsername.fromDeal.step.${index + 1}` as keyof Translations}
              values={{
                highlight: (chunks) => (
                  <Typography
                    className="font-semibold [font-size:inherit]"
                    color="text.primary"
                    component="span"
                  >
                    {chunks}
                  </Typography>
                ),
              }}
            />
          </Typography>
        </div>
      ))}
    </div>
  )
}
